var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticStyle:{"font-family":"sans-serif","font-weight":"bold"},attrs:{"align":"center"}},[_vm._v("Vă rog, așteptați...")])
}
var staticRenderFns = []

export { render, staticRenderFns }